document.addEventListener('DOMContentLoaded', function () {
  const roots = document.querySelectorAll('.product-colour-swatches');

  roots.forEach(function (root) {
    if (root.dataset.swatchesInitialised === 'true') return;
    root.dataset.swatchesInitialised = 'true';

    const blockId = root.dataset.blockId;
    const styleCode = (root.dataset.styleCode || '').trim();
    const apiBase = 'https://pencarrie-live-stock2.onrender.com';
    const calculatorShell = document.querySelector(
      '.product-calculator-shell[data-block-id="' + blockId + '"]'
    );
    const stockFeed = document.querySelector(
      '.product-colour-swatches-stock[data-block-id="' + blockId + '"]'
    );
    const stockFeedItems = stockFeed ? stockFeed.querySelector('[data-stock-feed-items]') : null;
    const stockFeedTitle = stockFeed ? stockFeed.querySelector('[data-stock-feed-title]') : null;

    const items = root.querySelectorAll('[data-colour-swatch-item]');
    const scrollContainer = root.querySelector('.product-colour-swatches__scroll');

    let pendingColourName = '';
    let observer = null;
    let calculatorVisibilityObserver = null;
    let stockData = null;
    let stockPromise = null;
    let stockFeedShown = false;

    function findColourInput() {
      return [...document.querySelectorAll('textarea')]
        .find(el => /chosen.*colour/i.test(
          (el.name || '') + ' ' + (el.getAttribute('data-identifier') || '')
        )) || null;
    }

    function applyPendingColourIfPossible() {
      const colourInput = findColourInput();
      if (!colourInput || !pendingColourName) return false;

      colourInput.value = pendingColourName;
      colourInput.dispatchEvent(new Event('input', { bubbles: true }));
      colourInput.dispatchEvent(new Event('change', { bubbles: true }));
      colourInput.focus();
      colourInput.blur();
      return true;
    }

    function startWatchingForColourInput() {
      if (observer) return;

      observer = new MutationObserver(function () {
        if (applyPendingColourIfPossible()) {
          stopWatchingForColourInput();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    function stopWatchingForColourInput() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    function revealCalculatorWhenReady() {
      const calculator = document.getElementById('calculator');
      const colourInput = findColourInput();
      if (!calculator || !colourInput) return false;

      calculator.classList.add('calculator-is-visible');

      if (calculatorShell && calculatorShell.parentNode) {
        calculatorShell.parentNode.removeChild(calculatorShell);
      }

      return true;
    }

    function watchForCalculatorVisibility() {
      if (calculatorVisibilityObserver) return;
      if (revealCalculatorWhenReady()) return;

      calculatorVisibilityObserver = new MutationObserver(function () {
        if (revealCalculatorWhenReady()) {
          if (calculatorVisibilityObserver) {
            calculatorVisibilityObserver.disconnect();
            calculatorVisibilityObserver = null;
          }
        }
      });

      calculatorVisibilityObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    function nudgeScrollableSwatches() {
      if (!scrollContainer) return;

      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      if (maxScroll <= 8) return;

      const target = Math.min(28, maxScroll);
      const startDelay = 550;
      const moveDuration = 850;
      const returnDuration = 850;
      const holdDelay = 180;

      function animateScroll(to, duration, callback) {
        const from = scrollContainer.scrollLeft;
        const start = performance.now();

        function step(now) {
          const elapsed = now - start;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 0.5 - Math.cos(progress * Math.PI) / 2;
          scrollContainer.scrollLeft = from + (to - from) * eased;

          if (progress < 1) {
            requestAnimationFrame(step);
          } else if (callback) {
            callback();
          }
        }

        requestAnimationFrame(step);
      }

      setTimeout(function () {
        animateScroll(target, moveDuration, function () {
          setTimeout(function () {
            animateScroll(0, returnDuration);
          }, holdDelay);
        });
      }, startDelay);
    }

    function normalizeColour(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '');
    }

    function getShortSizeLabel(size) {
      const map = {
        xxsmall: 'XXS',
        xsmall: 'XS',
        small: 'S',
        medium: 'M',
        large: 'L',
        xlarge: 'XL',
        xxlarge: 'XXL',
        '2xlarge': '2XL',
        '3xlarge': '3XL',
        '4xlarge': '4XL',
        '5xlarge': '5XL',
        '6xlarge': '6XL',
        '7xlarge': '7XL'
      };

      const key = (size || '').toString().replace(/[^a-z0-9]/gi, '').toLowerCase();
      return map[key] || size;
    }

    function getSortedSizes(sizes) {
      const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];

      return [].slice.call(sizes).sort(function (a, b) {
        const aShort = getShortSizeLabel(a);
        const bShort = getShortSizeLabel(b);
        const aIndex = sizeOrder.indexOf(aShort);
        const bIndex = sizeOrder.indexOf(bShort);

        if (aIndex === -1 && bIndex === -1) return aShort.localeCompare(bShort);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });
    }

    function getTrafficClass(stockNum) {
      if (stockNum === null) return '';
      if (stockNum === 0) return 'is-out';
      if (stockNum > 0 && stockNum <= 10) return 'is-low';
      return 'is-good';
    }

    function escapeStockText(value) {
      const element = document.createElement('span');
      element.textContent = String(value ?? '');
      return element.innerHTML;
    }

    function renderStockForColour(colourName) {
      if (!stockFeedItems) return;

      if (stockFeedTitle) {
        stockFeedTitle.textContent = 'Current Stock · ' + colourName;
      }

      if (!stockData) {
        stockFeedItems.innerHTML = '<div class="product-colour-swatches-stock__message">Unable to load live stock right now.</div>';
        return;
      }

      const colours = stockData.colours || [];
      const colourNames = stockData.colourNames || {};
      const matrix = stockData.matrix || {};
      const targetColour = normalizeColour(colourName);

      let matchedColourCode = null;

      colours.forEach(function (colourCode) {
        if (matchedColourCode) return;
        const candidate = colourNames[colourCode] || colourCode;
        if (normalizeColour(candidate) === targetColour || normalizeColour(colourCode) === targetColour) {
          matchedColourCode = colourCode;
        }
      });

      if (!matchedColourCode || !matrix[matchedColourCode]) {
        stockFeedItems.innerHTML = '<div class="product-colour-swatches-stock__message">Stock information is not currently available for ' + escapeStockText(colourName) + '.</div>';
        return;
      }

      const sizes = getSortedSizes(Object.keys(matrix[matchedColourCode] || {}));
      const isSingleSize = sizes.length === 1;

      const html = sizes.map(function (size) {
        const row = matrix[matchedColourCode][size];
        const stockNum = typeof row?.stockNum === 'number' ? row.stockNum : null;
        const stockValue = row?.availability === 'discontinued_unknown_stock' ? 'Discontinued · stock unavailable'
          : row?.availability === 'discontinued' ? 'Discontinued'
          : stockNum === null ? 'Unavailable'
          : stockNum === 0 ? 'Out of stock'
          : String(row?.stockRaw ?? stockNum) + (row?.availability === 'last_remaining' ? ' · Last remaining' : '');
        const sizeLabel = getShortSizeLabel(size);
        const trafficClass = getTrafficClass(stockNum);

        return '<div class="product-colour-swatches-stock__item">'
          + '<span class="product-colour-swatches-stock__dot ' + trafficClass + '"></span>'
          + (isSingleSize
            ? '<span class="product-colour-swatches-stock__value">' + escapeStockText(stockValue) + '</span>'
            : '<span class="product-colour-swatches-stock__size">' + escapeStockText(sizeLabel) + ':</span>'
              + '<span class="product-colour-swatches-stock__value">' + escapeStockText(stockValue) + '</span>')
          + '</div>';
      }).join('');

      stockFeedItems.innerHTML = html || '<div class="product-colour-swatches-stock__message">Stock information is not currently available for ' + escapeStockText(colourName) + '.</div>';
    }

    function showStockFeed() {
      if (!stockFeed || stockFeedShown) return;
      stockFeed.classList.add('is-visible');
      stockFeed.setAttribute('aria-hidden', 'false');
      stockFeedShown = true;
    }

    function fetchStockData() {
      if (!styleCode) return Promise.resolve(null);
      if (stockPromise) return stockPromise;

      stockPromise = fetch(apiBase + '/api/stock-by-style?styleCode=' + encodeURIComponent(styleCode))
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to load stock (' + res.status + ')');
          return res.json();
        })
        .then(function (data) {
          stockData = data;
          return data;
        })
        .catch(function (error) {
          console.error('Stock prefetch failed', error);
          stockPromise = null;
          return null;
        });

      return stockPromise;
    }

    nudgeScrollableSwatches();
    watchForCalculatorVisibility();
    const initialSwatch = Array.from(items).find(function (item) {
      return item.classList.contains('is-selected') || item.querySelector('.product-colour-swatches__radio')?.checked;
    }) || Array.from(items).find(function (item) { return item.getAttribute('data-colour-name'); });
    const initialColourName = initialSwatch?.getAttribute('data-colour-name') || '';
    if (styleCode && stockFeedItems && initialColourName) {
      // Preview stock immediately; choosing a calculator colour still requires a click.
      if (stockFeedTitle) stockFeedTitle.textContent = 'Current Stock · ' + initialColourName;
      stockFeedItems.innerHTML = '<div class="product-colour-swatches-stock__message">Checking live stock…</div>';
      showStockFeed();
      fetchStockData().then(function () {
        renderStockForColour(pendingColourName || initialColourName);
      });
    } else {
      fetchStockData();
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        const colourName = item.getAttribute('data-colour-name') || '';
        if (!colourName) return;

        pendingColourName = colourName;

        items.forEach(function (swatch) {
          swatch.classList.remove('is-selected');
        });
        item.classList.add('is-selected');

        const radio = item.querySelector('.product-colour-swatches__radio');
        if (radio) {
          radio.checked = true;
        }

        if (applyPendingColourIfPossible()) {
          stopWatchingForColourInput();
        } else {
          startWatchingForColourInput();
        }

        fetchStockData().then(function () {
          renderStockForColour(colourName);
          showStockFeed();
        });
      });
    });

    if (!applyPendingColourIfPossible()) {
      startWatchingForColourInput();
    }

    window.addEventListener('beforeunload', function () {
      pendingColourName = '';
      stopWatchingForColourInput();
      if (calculatorVisibilityObserver) {
        calculatorVisibilityObserver.disconnect();
        calculatorVisibilityObserver = null;
      }
    });
  });
});
